<script>
  export default {
    name: 'loading-overlay',

    props: {
      isLoading: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <span>Loading</span>
    </div>
    <slot v-if="!isLoading"></slot>
  </div>
</template>

<style src="./LoadingOverlay.scss" lang="scss" scoped></style>
